import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'loop',
  version: '1.1.0',
  properties: [
    {
      key: 'loopMode',
      label: 'Loop Mode',
      type: 'options',
      required: true,
      default: 'forEach',
      options: [
        { name: 'For Each Item', value: 'forEach' },
        { name: 'Fixed Count', value: 'count' },
      ],
    },
    {
      key: 'inputData',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].array }}',
      description: 'The array to loop over. Drag from the input panel or type the path.',
      displayOptions: {
        show: {
          loopMode: ['forEach'],
        },
      },
    },
    {
      key: 'count',
      label: 'Iterations',
      type: 'number',
      required: true,
      default: 10,
      typeOptions: {
        minValue: 1,
        maxValue: 1000,
      },
      description: 'Number of times to iterate',
      displayOptions: {
        show: {
          loopMode: ['count'],
        },
      },
    },
    {
      key: 'maxIterations',
      label: 'Max Iterations',
      type: 'number',
      required: false,
      default: 1000,
      typeOptions: {
        minValue: 1,
        maxValue: 10000,
      },
      description: 'Safety limit to prevent runaway loops',
    },
  ],
};

export default schema;
